/* eslint-disable */
import axios from 'axios'

const baseUrl = process.env.VUE_APP_BASE_API + "/excursion/subzones/";


// Módulo para obtener subzones

const state = {
  subzones: [],
  subzone: [],
  subzonesListAdmin: [],
  subzonesAllListAdmin: [],
}

const mutations = {
  SET_SUBZONES_LIST_ADMIN(state, subzones) {
    state.subzonesListAdmin = subzones
  },
  RESET_SUBZONES_LIST_ADMIN(state) {
    state.subzonesListAdmin = []
  },
  SET_ALL_SUBZONES_LIST_ADMIN(state, subzones) {
    state.subzonesAllListAdmin = subzones
  }
}

const actions = {

  async getSubzonesBySuprazone({
    commit, dispatch
  }, data) {
    return axios
      .get(
        baseUrl + 
        '?pickup_zone__supra_zone=' + data.suprazone_id
      )
      .then(response => {
        commit('SET_SUBZONES_LIST_ADMIN', response.data)
        return response.data
      })
  },

  async getSubzones({
    commit, dispatch
  }, data) {
    return axios
      .get(
        baseUrl
      ).then(response => {
        commit('SET_ALL_SUBZONES_LIST_ADMIN', response.data)
        return response.data
      })
  },
  async getSubzonesGroupByPickupzone({
    commit, dispatch
  }, data) {
    return axios
      .get(
        baseUrl + 'subzones_groupby_pickupzones/?supra_zone_id=' + data.suprazone_id
      ).then(response => {
        commit('SET_SUBZONES_LIST_ADMIN', response.data)
        return response.data
      })
  },

  async createSubzone({
    commit, dispatch
  }, data) {
    await axios
      .post(baseUrl, data.payload)
      .then( response => {
        dispatch('getSubzonesGroupByPickupzone', data)
        return response.data
      })
  },

  async updateSubzone({
    commit, dispatch
  }, data) {
    console.log('data', data)
    await axios
      .patch(baseUrl + data.subzone_id + '/', data.payload)
      .then(response => {
        dispatch('getSubzonesGroupByPickupzone', data)
        return response.data
      })
  },

  async deleteSubzone({
    commit, dispatch
  }, data) {
    return axios
      .delete(baseUrl + data.subzone_id + '/')
      
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
